import Vue from 'vue'

import VueGoogleMaps from 'vue-googlemaps'
Vue.use(VueGoogleMaps, {
    load: {
        apiKey: 'AIzaSyByt21nUcRfCa6M1_Ty5DKPnax3HQvHizQ',
        libraries: [],
        useBetaRenderer: false
    }
})

import 'vue-googlemaps/dist/vue-googlemaps.css'
